<template>
  <section class="highlight">
    <div class="container">
      <a-typography-title :level="1">
        方案亮点功能
      </a-typography-title>
      <a-row>
        <a-col :xs="24" :md="12">
          <div class="image" />
        </a-col>
        <a-col :xs="24" :md="12">
          <div class="list">
            <div v-for="item in expand.list"
                 class="item">
              <a-typography-title :level="5">
                {{ item.title }}
              </a-typography-title>
              <a-typography-paragraph>
                {{ item.text }}
              </a-typography-paragraph>
            </div>
          </div>
        </a-col>
      </a-row>
    </div>
  </section>
</template>

<script lang="ts" type="text/tsx">
import { DataInterface } from '@interface/public';

export default {
  name: 'plan_highlight',
  data(): DataInterface {
    return {
      expand: {
        list: [
          {
            title: '决策支持',
            text: '系统全景可视化，快速定位业务故障，提供有效的运维决策建议。'
          },
          {
            title: '指标管理',
            text: '支持冗余度等更贴近业务现状的指标，实现高度精细化运营。'
          },
          {
            title: '发布部署',
            text: '支持定制发布模板，从而进行流水线式的发布部署，显著提升效率。'
          },
          {
            title: '算力模板',
            text: '将算力模板化，记录算力规格、网络等信息，降低运维操作门槛。'
          },
          {
            title: '多云对接',
            text: '对接并高效管理AWS、阿里云、华为云等众多云厂商资源。'
          }
        ]
      }
    };
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@image: '@{src_image}page/planOperation/';

.highlight {
  overflow: hidden;
  position: relative;
  padding: 0 @padding;
  background: @color_white;
  
  .container {
    position: relative;
    max-width: @grid_xl;
    padding: @space 0;
    margin: 0 auto;
    .borderBox();
  }
}

h1.ant-typography {
  margin: 0;
  .font(center, @title, @color_12, @title, true);
}

.ant-row {
  margin: @margin 0 0;
}

.image {
  overflow: hidden;
  position: relative;
  height: 100%;
  .bg('@{image}highlight_bg_1.jpg');
  background-size: cover;
  
  &::before {
    content: '';
    display: block;
    .position(absolute, 50%, auto, auto, 50%);
    .bg('@{image}highlight_image.png', 481px, 379px, true);
    .transform(translate(calc(~'-50% + var(--mouse-x,0px) * -0.01'), calc(~'-50% + var(--mouse-y,0px) * -0.01')) scale(0.9));
  }
}

.list {
  position: relative;
  padding: 15px;
  .bg('@{image}highlight_bg_2.jpg');
  border: 1px solid @color_15;
  .borderBox();
  background-size: cover;
  
  .item {
    @wh: 50px;
    position: relative;
    padding-left: 75px;
    margin: 20px 0 0;
    
    .loop(@i) when (@i<=5) {
      &:nth-child(@{i})::after {
        background-position-x: -(-1+@i)*@wh;
      }
      .loop(@i+1);
    }
    .loop(1);
    
    &:first-child {
      margin: 0 !important;
    }
    
    &::before,
    &::after {
      content: '';
      display: block;
      position: absolute;
    }
    
    &::before {
      top: 20px;
      left: 0;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background: #bdc9ff;
    }
    
    &::after {
      top: 0;
      left: 15px;
      width: @wh;
      height: @wh;
      .bg('@{image}highlight_icon.png', @wh*5, @wh);
    }
    
    h5.ant-typography {
      margin: 0;
      .font(justify, @text_big, @color_12, @text_big, true);
    }
    
    div.ant-typography {
      margin: 5px 0 0;
      .font(justify, @text+@line, @color_13, @text);
    }
  }
}

@media screen and (max-width: -1px+@grid_md) {
  .highlight {
    .container {
      padding: @space_mo 0;
    }
  }
  
  h1.ant-typography {
    .font(center, @title_mo+@line_mo, @color_12, @title_mo, true);
  }
  
  .ant-row {
    margin: @margin_mo 0 0;
  }
  
  .image {
    height: 200px;
    
    &::before {
      .transform(translate(-50%, -50%) scale(0.5));
    }
  }
  
  .list {
    padding: 20px 20px 20px 15px;
    
    .item {
      margin: 10px 0 0;
      
      h5.ant-typography {
        .font(justify, @text_big_mo, @color_12, @text_big_mo, true);
      }
      
      div.ant-typography {
        .font(justify, @text_mo+@line_mo, @color_13, @text_mo);
      }
    }
  }
}
</style>